import { createTransform } from 'redux-persist';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';

import { InitStateNames, russian } from './constants';

// `language` is a static constant, so it is stripped before persisting and put
// back on rehydrate. Otherwise UI strings added in a newer release would be
// shadowed by the copy saved by an older version of the app.
const settingsTransform = createTransform(
  (inboundState) => {
    // eslint-disable-next-line no-unused-vars
    const { language, ...rest } = inboundState;
    return rest;
  },
  (outboundState) => ({
    ...outboundState,
    language: russian
  }),
  { whitelist: [InitStateNames.settings] }
);

const persistConfig = {
  key: 'ru-hymns',
  storage,
  whitelist: [InitStateNames.bookmarks, InitStateNames.history, InitStateNames.settings],
  // Merge one level deeper so settings added in a new release keep their
  // defaults instead of being dropped by the persisted settings object.
  stateReconciler: autoMergeLevel2,
  transforms: [settingsTransform]
};

export default persistConfig;
